// @flow

// import { FieldTextStateless } from '@atlaskit/field-text';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';


/**
 * The donorbox application.
 */
class clickPledgeDialog extends Component<*> {


    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
    */
    render() {
        const { _getCurl } = this.props;

        return (
            <Dialog
                cancelKey = { 'dialog.close' }
                disableOverlay = { true }
                height = '500px'
                iconAdd = { true }
                iconSrc = '../images/cnp-connect.png'
                submitDisabled = { true }
                titleKey = 'clickandpledge.titleDialog'
                width = 'large'>
                <div className = 'holds-the-iframe' >
                    <iframe
                        height = '500px'
                        src = { _getCurl }
                        width = '100%' />
                </div>
            </Dialog>
        );

    }


}

// https://donorbox.org/donation-help-cabs-drivers-to-feed-their-loved-ones
/**
* Redux _mapDispatchToProps .
*
* @param {number} state - The Object.
* @returns  {string} For the donorbox url.
*/
export function _mapStateToProps(state: any) {
    const { getCUrl } = state['features/clickandpledge'];

    return {
        _getCurl: getCUrl

    };
}


export default translate(connect(_mapStateToProps, null)(clickPledgeDialog));
